import type { FeedConfiguration, FeedTask } from '../models/Ou';
import { feedIngestServiceAxios } from './interceptor';

const FeedIngestService = {
  async upsertFeed(payload: FeedConfiguration): Promise<FeedConfiguration> {
    // curl --request POST \
    //   --url https://feedingestservice-dev01-v1.mediapipe.com/feeds \
    //   --header 'Authorization: Bearer a38085fa461a820efdcade8654d60da86524b2c2c88c89ce2cf20305dd39ecc0' \
    //   --header 'Content-Type: application/json' \
    //   --data '{
    // 	"Enabled": true,
    // 	"FeedName": "testfeed3",
    // 	"FeedUrl": "https://platform.videoelephant.com/mrss/fa642904/index.xml",
    // 	"ouId":"fe5d4764-87e0-49d1-a171-a4e56ec36d06"
    // }'
    const buildUrl = () => {
      const path = `feeds`;
      return path;
    };

    const url = buildUrl();
    try {
      const res = await feedIngestServiceAxios.post(url, payload);
      return res.data;
    } catch (err) {
      throw new Error();
    }
  },

  async enqueueTask(payload: FeedConfiguration): Promise<FeedConfiguration> {
    // curl --request POST \
    //   --url https://feedingestservice-dev01-v1.mediapipe.com/feeds \
    //   --header 'Authorization: Bearer a38085fa461a820efdcade8654d60da86524b2c2c88c89ce2cf20305dd39ecc0' \
    //   --header 'Content-Type: application/json' \
    //   --data '{
    // 	"Enabled": true,
    // 	"FeedName": "testfeed3",
    // 	"FeedUrl": "https://platform.videoelephant.com/mrss/fa642904/index.xml",
    // 	"ouId":"fe5d4764-87e0-49d1-a171-a4e56ec36d06"
    // }'
    const buildUrl = () => {
      const path = `tasks`;
      return path;
    };

    const url = buildUrl();
    try {
      const res = await feedIngestServiceAxios.post(url, payload);
      return res.data;
    } catch (err) {
      throw new Error();
    }
  },
  async batchGet(payload: string[]): Promise<FeedConfiguration[]> {
    const buildUrl = () => {
      const path = `feeds/batchget`;
      return path;
    };

    const url = buildUrl();
    try {
      const res = await feedIngestServiceAxios.post(url, payload);
      return res.data;
    } catch (err) {
      throw new Error();
    }
  },
  async deleteFeed(id: string): Promise<any> {
    const buildUrl = () => {
      const path = `feeds/${id}`;
      return path;
    };

    const url = buildUrl();
    try {
      const res = await feedIngestServiceAxios.delete(url);
      return res;
    } catch (err) {
      throw new Error();
    }
  },

  async validateFeed(feedUrl: string, validateEntireFeed: boolean = false): Promise<any> {
    const buildUrl = () => {
      let path = `feeds/validate`;
      if (validateEntireFeed) {
        path += '?validateEntireFeed=true';
      }
      return path;
    };

    const url = buildUrl();
    const data = { Url: feedUrl };
    return feedIngestServiceAxios.post(url, data);
  },

  // https://feedingestservice-dev01-v1.mediapipe.com/feeds/feeditem/c8801903-18a3-4564-afdc-b8ce901b1038-2BGqftco
  async deleteFeedsItem(ouId: string, id: string): Promise<any> {
    const buildUrl = () => {
      const path = `feeds/feeditem/${ouId}-${id}`;
      return path;
    };

    const url = buildUrl();
    try {
      const res = await feedIngestServiceAxios.delete(url);
      return res;
    } catch (err) {
      throw err;
    }
  },
  async deleteFeedItemById(id: string): Promise<any> {
    const buildUrl = () => {
      const path = `feeds/feeditem/${id}`;
      return path;
    };

    const url = buildUrl();
    try {
      const res = await feedIngestServiceAxios.delete(url);
      return res;
    } catch (err) {
      throw err;
    }
  },

  async getFeedByOuId(ouId: string): Promise<FeedConfiguration> {
    const url = `feeds/ou/${ouId}?loadHealth=true`;
    try {
      const res = await feedIngestServiceAxios.get(url);
      return res.data;
    } catch (err) {
      throw new Error();
    }
  },
  async getTasksByOuId(ouId: string): Promise<FeedTask[]> {
    const url = `tasks/ou/${ouId}`;
    try {
      const res = await feedIngestServiceAxios.get(url);
      return res.data;
    } catch (err) {
      throw new Error();
    }
  },
  async getTasksByTaskId(id: string): Promise<FeedTask[]> {
    const url = `tasks/items/${id}`;
    try {
      const res = await feedIngestServiceAxios.get(url);
      return res.data;
    } catch (err) {
      throw new Error();
    }
  },

  async getFeed(id: string): Promise<FeedConfiguration> {
    const buildUrl = () => {
      const path = `feeds/${id}?loadHealth=true`;
      return path;
    };

    const url = buildUrl();
    try {
      const res = await feedIngestServiceAxios.get(url);
      return res.data;
    } catch (err) {
      throw new Error();
    }
  },
};

export { FeedIngestService };
